import SpamPanel from './SpamPanel';

export default SpamPanel;
